if (!customElements.get('ol-production-slider')) {
  customElements.define('ol-production-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.pauseButton = this.querySelector('[data-pause]');
      this.desktop = matchMedia('(min-width: 750px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.stopped = false;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.setAttribute('data-ready', '');
      this.querySelector('.ol-production__arrows').hidden = false;
      this.select(0);
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index, true), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next, true);
          this.tabs[next].focus();
        }, options);
      });
      this.querySelector('[data-previous]').addEventListener('click', () => this.select((this.index + this.tabs.length - 1) % this.tabs.length, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.select((this.index + 1) % this.tabs.length, true), options);
      this.pauseButton.addEventListener('click', () => {
        this.stopped = !this.stopped;
        this.updateTimer();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.updateTimer(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.updateTimer(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.updateTimer(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.updateTimer(); }
      }, options);
      this.querySelectorAll('.ol-pallet-mini__action').forEach(link => link.addEventListener('click', () => { this.stopped = true; this.updateTimer(); }, options));
      const panels = this.querySelector('.ol-production__panels');
      panels.addEventListener('touchstart', event => {
        if (event.touches.length === 1) this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      panels.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select((this.index + (dx < 0 ? 1 : this.tabs.length - 1)) % this.tabs.length, true);
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.updateTimer(), options);
      this.desktop.addEventListener('change', () => this.updateTimer(), options);
      this.reduced.addEventListener('change', () => this.updateTimer(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updateTimer();
      }, { threshold: 0.2 });
      this.observer.observe(this);
      this.updateTimer();
    }
    select(index, manual = false) {
      this.index = index;
      if (manual) this.stopped = true;
      this.tabs.forEach((tab, position) => {
        const active = position === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[position].toggleAttribute('data-active', active);
        this.panels[position].setAttribute('aria-hidden', String(!active));
        this.panels[position].inert = !active;
      });
      this.updateTimer();
    }
    updateTimer() {
      clearTimeout(this.timer);
      const allowed = this.desktop.matches && !this.reduced.matches && this.tabs.length > 1;
      this.pauseButton.hidden = !allowed;
      this.pauseButton.setAttribute('aria-label', this.stopped ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.pauseButton.textContent = this.stopped ? this.dataset.playShort : this.dataset.pauseShort;
      if (allowed && !this.stopped && this.inView && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setTimeout(() => this.select((this.index + 1) % this.tabs.length), 7000);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
